// extracted by mini-css-extract-plugin
export var active = "_3n-7";
export var container = "_3n-0";
export var evenWidth = "_3n-4";
export var large = "_3n-5";
export var outlet = "_3n-8";
export var slide = "_3n-2";
export var small = "_3n-6";
export var tab = "_3n-3";
export var tabs = "_3n-1";